import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    class: "text-sm text-(--colors-text-body-subtle)",
    "data-testid": "donation-settings-templates-required-hint"
};
const _hoisted_2 = { class: "grid grid-cols-1 gap-4 sm:grid-cols-2" };
import { Alert, SelectInput } from "@eudonet/opal";
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import DonationSettingsSection from "./DonationSettingsSection.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DonationSettingsDocumentTemplatesTab',
    props: {
        individualTemplateId: {},
        organizationTemplateId: {},
        options: {},
        loadError: { type: Boolean },
        showRequiredErrors: { type: Boolean }
    },
    emits: ["update:individualTemplateId", "update:organizationTemplateId"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const { t } = useI18n();
        const selectableOptions = computed(() => [
            { value: "", label: t("finance.taxReceipts.settings.templates.noneOption") },
            ...props.options,
        ]);
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DonationSettingsSection, {
                title: _ctx.$t('finance.taxReceipts.settings.templates.title'),
                subtitle: _ctx.$t('finance.taxReceipts.settings.templates.subtitle'),
                "test-id": "donation-settings-templates"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$t("finance.taxReceipts.settings.requiredFieldsHint")), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_unref(SelectInput), {
                            "model-value": __props.individualTemplateId ?? '',
                            options: selectableOptions.value,
                            label: _ctx.$t('finance.taxReceipts.settings.templates.individualLabel'),
                            hint: __props.loadError ? _ctx.$t('finance.taxReceipts.settings.templates.loadError') : undefined,
                            error: __props.showRequiredErrors && !__props.loadError && __props.individualTemplateId === null ? _ctx.$t('finance.donationModuleSettings.errors.required') : undefined,
                            disabled: __props.loadError,
                            required: "",
                            "full-width": "",
                            "data-testid": "donation-settings-templates-individual",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (emit('update:individualTemplateId', $event || null)))
                        }, null, 8 /* PROPS */, ["model-value", "options", "label", "hint", "error", "disabled"]),
                        _createVNode(_unref(SelectInput), {
                            "model-value": __props.organizationTemplateId ?? '',
                            options: selectableOptions.value,
                            label: _ctx.$t('finance.taxReceipts.settings.templates.organizationLabel'),
                            hint: __props.loadError ? _ctx.$t('finance.taxReceipts.settings.templates.loadError') : undefined,
                            error: __props.showRequiredErrors && !__props.loadError && __props.organizationTemplateId === null ? _ctx.$t('finance.donationModuleSettings.errors.required') : undefined,
                            disabled: __props.loadError,
                            required: "",
                            "full-width": "",
                            "data-testid": "donation-settings-templates-organization",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (emit('update:organizationTemplateId', $event || null)))
                        }, null, 8 /* PROPS */, ["model-value", "options", "label", "hint", "error", "disabled"])
                    ]),
                    (__props.individualTemplateId === null || __props.organizationTemplateId === null)
                        ? (_openBlock(), _createBlock(_unref(Alert), {
                            key: 0,
                            color: "warning",
                            message: _ctx.$t('finance.taxReceipts.settings.templates.generationBlocked'),
                            "data-testid": "donation-settings-templates-blocked"
                        }, null, 8 /* PROPS */, ["message"]))
                        : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["title", "subtitle"]));
        };
    }
});
